<template functional>
  <div class="flex flex-col gap-0.5">
    <div class="flex items-center justify-center gap-1">
      <check-marker
        :size="16"
        :item="{
          id: props.item.id,
          marker: props.item.marker,
          target: 'order',
        }"
      />
      <note-entry
        :size="16"
        :options="{
          name: props.item.container_no,
          id: props.item.id,
          type: 'Container',
          category: 'admin',
          noted: props.item.admin_noted,
        }"
      />
      <container-colorify
        :size="16"
        :item="{ id: props.item.id, color: props.item.color }"
      />
    </div>
    <div class="flex items-center justify-center gap-1">
      <slot v-if="props.item.brokered">
        <broker-orders :id="props.item.id" :size="16" placement="bottom" />
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "fltl-action",
  functional: true,
  props: {
    item: Object,
    options: Object,
  },
};
</script>
